import * as React from 'react';
import { connect } from 'react-redux';

import { IBranding, IDocument } from '../../infrastructure/interfaces';
import BrandingListEditorForm from '../DocumentEditor/BrandingListEditorForm';
import { productType } from '../../infrastructure/ProductType';

export interface IBrandingsListChoosingProps {
  document: IDocument;
  brandings: IBranding[];
  toggleBranding(brand: IBranding): void;
}

export interface IBrandingsListChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
    return {
    };
};

const mapStateToProps = (state: any): any => {
    return {
        document: state.document,
        brandings: state.wizard.brandings,
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class BrandingsListChoosing extends React.Component<IBrandingsListChoosingProps, IBrandingsListChoosingState> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            {this.props.document.type === productType.Bulletin
              ? 'Select branding for footer:'
              : 'Select branding for back cover:'}
          </div>
          <div className="stepMessage2">
            You can change this selection later
          </div>
          <div className="stepMessageWarning">
              "Does not apply to Seed Covers"
          </div>
        </div>
        <BrandingListEditorForm
          document={this.props.document}
          brandingsList={this.props.brandings}
          onBrandChange={this.props.toggleBranding}
          className="stepContent settingsCropsListContainer--logo"
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/BrandingsListChoosing.tsx